import Footer from "./components/Footer"

function DeleteData(){
    return(<>
        <div className="deleteFormFather" style={{display:"flex", justifyContent:"center", alignItems:"center", height:"100vh"}}>
            <h1 style={{color:"white", zIndex:10}}>Esta Pagina Todavia Esta En Desarrollo</h1>
        </div>
        <Footer />
    </>)
}

export default DeleteData